/* eslint-disable react/jsx-props-no-spreading */
import { useTracking } from '@folklore/tracking';
import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

// import * as AppPropTypes from '../../lib/PropTypes';
import * as CardComponents from '../cards/promotions';
import Notification from './Notification';

import styles from '../../styles/popups/promotion-notification.module.css';

// @TODO: Swtch input type
const propTypes = {
    promotion: PropTypes.shape({
        id: PropTypes.string.isRequired,
        handle: PropTypes.string,
        type: PropTypes.string.isRequired,
        closeable: PropTypes.bool.isRequired,
    }).isRequired,
    delay: PropTypes.number,
    className: PropTypes.string,
    onClosed: PropTypes.func,
};

const defaultProps = {
    delay: 1000,
    className: null,
    onClosed: null,
};

function PromotionNotification({ promotion, delay, className, onClosed, ...props }) {
    const [opened, setOpened] = useState(delay === null);
    const [hasOpened, setHasOpened] = useState(opened);
    const tracking = useTracking();

    const { id, handle, type = null, closeable = true, withTransition = false, closeTrigger = null } = promotion;
    const PromotionComponent = getComponentFromName(CardComponents, type, CardComponents.Default);

    useEffect(() => {
        if (closeTrigger === null) {
            return () => {};
        }
        tracking.triggers.register(`promotion_popup_close_${id}`, closeTrigger, () => {
            setOpened(false);
        });
        return () => {
            tracking.triggers.unregister(`promotion_popup_close_${id}`);
        }
    }, [id, tracking, closeTrigger]);

    useEffect(() => {
        if (delay === null) {
            return () => {};
        }
        const timeout = setTimeout(() => {
            setOpened(true);
            setHasOpened(true);
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [delay]);

    const onRequestClose = useCallback(() => {
        setOpened(false);
        tracking.trackPromotion(promotion, 'close');
    }, [setOpened, tracking, promotion]);

    const onPromotionComplete = useCallback(() => {
        setOpened(false);
        tracking.trackPromotion(promotion, 'complete');
    }, [setOpened, tracking, promotion]);

    const onPromotionCancel = useCallback(() => {
        setOpened(false);
        tracking.trackPromotion(promotion, 'cancel');
    }, [setOpened, tracking, promotion]);

    return PromotionComponent !== null ? (
        <Notification
            id={`promotion-${handle || id}`}
            opened={opened}
            withTransition
            withoutCloseButton={!closeable}
            className={classNames([styles.container, className])}
            onClosed={hasOpened ? onClosed : null}
            requestClose={onRequestClose}
        >
            <PromotionComponent
                // withTransition
                {...promotion}
                {...props}
                invert
                className={styles.card}
                onComplete={onPromotionComplete}
                onCancel={onPromotionCancel}
            />
        </Notification>
    ) : null;
}

PromotionNotification.propTypes = propTypes;
PromotionNotification.defaultProps = defaultProps;

export default PromotionNotification;
